export default __webpack_public_path__ + "static/media/work-in-portugal.ee74a5e9.jpg";